// Stands in for a screenContext shed for size, so it describes the same screen
// and is route-scoped in the same way. Shared so the code that writes it and the
// code that treats it as route-scoped cannot drift apart.
export var SCREEN_CONTEXT_OMITTED_KEY = 'screenContextOmitted';